class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {


      const currentProd = this.parentElement.parentElement;
      const currentProdId = currentProd.getAttribute('data-cart-item-key');
      const arrayAdditional = currentProd.querySelectorAll('[data-additional-price]');
      const updates = {[currentProdId]: 0};

      arrayAdditional.forEach((element) => {
        const cartItemId = element.getAttribute('data-cart-item-key');
        updates[cartItemId] = 0;
      });

      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(updates, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        }
      ];
  }
  cartCount(root = `${Shopify.routes.root}cart.js`) {
    fetch(root, { credentials: 'same-origin' })
      .then(response => response.json())
      .then(cart => {
        const cartCount = cart.items.reduce((count, element) => {
          if (element.properties && element.properties._main_group_product) {
            return count + element.quantity;
          }
          return count;
        }, 0);

        const cartCountElement = document.querySelector('.header__icon--cart');
        const cartCountElements = document.querySelector('.header__icon--cart .cart-count-bubble');
        const count = document.querySelector('.cart-basket-count');

        function animateCountChange() {
          cartCountElement.animate(
            [
              { transform: 'scale(1)' },
              { transform: 'scale(1.3)' },
              { transform: 'scale(1)' },
            ],
            {
              duration: 1000,
              iterations: 1,
            }
          );
        }

        if (cartCount > 0) {
          animateCountChange();
          cartCountElements.classList.remove('hidden');
          count.innerHTML = cartCount;
        } else {
          cartCountElements.classList.add('hidden');
        }
      });
  };

  recalculateCartDrawerPrices () {
    const productBlock = document.querySelectorAll('[data-count]');
    productBlock.forEach(section => {
          const additionalPrices = section.querySelectorAll('[data-additional-price]');

          // Create an array to store all additional prices
          const additionalPriceValues = [];

          additionalPrices.forEach(additionalPriceElement => {
              const additionalPriceValue = parseFloat(additionalPriceElement.getAttribute('data-additional-price'));
              if (!isNaN(additionalPriceValue)) {
                  additionalPriceValues.push(additionalPriceValue);
              }
          });


          const productPrice = section.querySelector('.product-price');
          const localizationForm = document.querySelector('localization-form .localization-form__button');
          const validSymbol = localizationForm.getAttribute('valid-symbol');
          console.log(productPrice);


          if (productPrice && additionalPriceValues.length > 0) {

              const currentPrice = parseFloat(productPrice.getAttribute('data-original-price'));
              const sumOfAdditionalPrices = additionalPriceValues.reduce((a, b) => a + b, 0);
              const newPrice = currentPrice + sumOfAdditionalPrices;
                productPrice.innerHTML = Shopify.formatMoney(newPrice, `${validSymbol} {{amount}}`);
          }
      });
  }

  additionalDropdowns() {
    const vectorIcons = document.querySelectorAll('.product-details__container');
    const blockFlexes = document.querySelectorAll('.additional_group-flexx');

    blockFlexes.forEach((blockFlex) => {
      blockFlex.style.maxHeight = '0px';
    });

    vectorIcons.forEach((vectorIcon) => {
      vectorIcon.addEventListener('click', (e) => {
        const clickedVectorIcon = e.currentTarget;
        const flexBlock = clickedVectorIcon.querySelector('.additional_group-flexx');
        if(flexBlock) {
          const isSlideDown = flexBlock.classList.contains('slide-down');

          flexBlock.classList.toggle('slide-down');
          const maxHeight = isSlideDown ? '0px' : flexBlock.scrollHeight + 'px';
          flexBlock.style.maxHeight = maxHeight;
        }
      });
    });
  }

  updateQuantity(prodIds, quantity, name) {
    const body = JSON.stringify({
      quantity,
      sections: 'cart-drawer',
      updates: prodIds
    });
    console.log( body, 'body')
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log(parsedState , 'parsedState')
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.cartCount()
        this.recalculateCartDrawerPrices()
        this.additionalDropdowns()
        this.disableLoading();
        if (window.location.href.includes('/cart')) {
          window.location.reload();
        }
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    // this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
